import generateUtilityClasses from '@mui/material/generateUtilityClasses';

export const collapseClasses = generateUtilityClasses('AFCollapse', [
  'root',
  'expandIcon',
  'contentWrapper'
]);
